import { render } from "./TableComp.vue?vue&type=template&id=0f8f467b"
import script from "./TableComp.vue?vue&type=script&lang=js"
export * from "./TableComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__